import { defineMessages } from 'react-intl';

export default defineMessages({
  'male' : {
    'id' : 'gender.male.title',
    'defaultMessage' : 'Male'
  },
  'female' : {
    'id' : 'gender.female.title',
    'defaultMessage' : 'Female'
  }
});